import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./index.css";
import FullScreenLoader from "./components/FullScreenLoader";

const LoginPage = React.lazy(() => import("./pages/Login/LoginPage"));
const ForgotPassword = React.lazy(() => import("./pages/Login/ForgotPassword"));
const RegisterPage = React.lazy(
  () => import("./pages/Registration/RegisterPage"),
);
const HomePage = React.lazy(() => import("./pages/HomePage"));
const ProfilePage = React.lazy(() => import("./pages/ProfilePage"));
const CreateProfilePage = React.lazy(
  () => import("./pages/Registration/InfoPage"),
);
const DesignPage = React.lazy(() => import("./pages/Registration/DesignPage"));
const ProfileRedirect = React.lazy(() => import("./pages/ProfileRedirect"));
const MessagesPage = React.lazy(() => import("./pages/MessagesPage"));
const DiscoverPage = React.lazy(() => import("./pages/DiscoverPage"));
const TermsOfServicePage = React.lazy(
  () => import("./pages/TermsOfServicePage"),
);
const PrivacyPolicyPage = React.lazy(() => import("./pages/PrivacyPolicyPage"));

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<FullScreenLoader />}>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route
            path="/register/profile-info"
            element={<CreateProfilePage />}
          />
          <Route path="/login/forgot-password" element={<ForgotPassword />} />
          <Route path="/register/profile-design" element={<DesignPage />} />
          <Route path="/profile/:uid" element={<ProfilePage />} />
          <Route path="/profile/:uid/message" element={<MessagesPage />} />
          <Route path="/discover" element={<DiscoverPage />} />
          <Route path="/terms" element={<TermsOfServicePage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/my-profile" element={<ProfileRedirect />} />
          <Route path="/" element={<HomePage />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Failed to find the root element");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
